<div *ngIf="item && item.cells" class="container flex flex-row justify-between items-center">
  <div class="grid-cell-ellipsis"
       matTooltip="{{item.cells[fieldDefinition.key] ? (item.cells[this.fieldDefinition.key].value?.toolTip ? item.cells[this.fieldDefinition.key].value?.toolTip : item.cells[fieldDefinition.key].displayText) : ''}}">
    {{item.cells[fieldDefinition.key] ? item.cells[fieldDefinition.key].displayText : ''}}
  </div>
  <button *ngIf="!disabled" (click)="onClicked('Edit')" mat-icon-button class="icon-dropdown-button">
    <mat-icon>create</mat-icon>
  </button>
</div>
